import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { initMetaPixel, initGoogleAnalytics } from './utils/analytics';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
// Lazy-load below-fold components to reduce initial bundle size
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const CountdownTimer = lazy(() => import('./components/CountdownTimer').then(m => ({
  default: m.CountdownTimer
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const AulaListaSection = lazy(() => import('./components/AulaListaSection').then(m => ({
  default: m.AulaListaSection
})));
const ComparisonTableExtended = lazy(() => import('./components/ComparisonTableExtended').then(m => ({
  default: m.ComparisonTableExtended
})));
const TestimonialsPreGuarantee = lazy(() => import('./components/TestimonialsPreGuarantee').then(m => ({
  default: m.TestimonialsPreGuarantee
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
function LazyFallback() {
  return <div className="w-full py-12 flex items-center justify-center bg-brand-dark" data-id="element-0">
      <div className="w-8 h-8 border-2 border-brand-yellow border-t-transparent rounded-full animate-spin" data-id="element-1" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Immediate preconnect for critical assets - only the most important ones
    const preconnect = (url: string, crossOrigin = false) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = url;
      if (crossOrigin) link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    };
    // Only preconnect to the most critical origins to avoid saturating the network
    preconnect('https://fonts.googleapis.com');
    preconnect('https://fonts.gstatic.com', true);
    preconnect('https://cdn.magicpatterns.com');
    // Defer non-critical analytics even further
    const timer = setTimeout(() => {
      initMetaPixel('1687764378881323');
      initGoogleAnalytics('G-8VEH4J7KBQ');
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-yellow selection:text-black" data-id="element-2">
      {/* Above-the-fold: loaded eagerly */}
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />

      {/* Priority below-fold: testimonials + pricing CTA */}
      <Suspense fallback={<LazyFallback data-id="element-6" />} data-id="element-5">
        <Testimonials data-id="element-7" />
        <ProblemSection data-id="element-8" />

        <div className="bg-premium-gradient" data-id="element-9">
          <TomosSection data-id="element-10" />
        </div>

        <BonusSection data-id="element-11" />
        <CountdownTimer data-id="element-12" />

        <div className="bg-premium-gradient" data-id="element-13">
          <PricingSection data-id="element-14" />
        </div>

        <AulaListaSection data-id="element-15" />

        <div className="bg-premium-gradient" data-id="element-16">
          <ComparisonTableExtended data-id="element-17" />
        </div>

        <TestimonialsPreGuarantee data-id="element-18" />
        <Guarantee data-id="element-19" />
        <FAQ data-id="element-20" />

        <div className="bg-premium-gradient" data-id="element-21">
          <ComparisonTable data-id="element-22" />
        </div>

        <FinalCTA data-id="element-23" />

        {/* Final closing message */}
        <div className="max-w-xl mx-auto px-5 py-12 text-center" data-id="element-24">
          <p className="text-gray-400 text-lg mb-4" data-id="element-25">
            Esto no es solo estudiar enfermería…
          </p>
          <p className="text-brand-yellow text-2xl font-black mb-4" data-id="element-26">
            👉 es dejar de improvisar y empezar a actuar con seguridad
          </p>
          <p className="text-white text-3xl font-black" data-id="element-27">
            💥 Y eso cambia todo.
          </p>
        </div>

        <PurchasePopup data-id="element-28" />
      </Suspense>
    </div>;
}